export const set = (store, key, value) => {
  store.state.cache.set(key, value);
  store.setState({ cache: new Map(store.state.cache) });
};
